import React, { useEffect, useContext } from 'react';
import {
  generatePath,
  Switch,
  Route,
  useHistory,
  useLocation,
  Redirect,
  matchPath,
} from 'react-router-dom';
import api from 'Api';
import { STORAGE_KEYS, USER_STATUS } from 'Enums';
import useConfigSettings from "Hooks/useConfigSettings";
import RedeemDetails from './RedeemDetails';
import RedemptionSummary from './RedeemSummary';
import RedeemQr from './RedeemQr';
import RedeemFinish from './RedeemFinish';
import { AuthContext } from 'States/auth/authState';
import { ConfigContext } from 'States/config/configState';
import useKycTierCheck from 'Hooks/useKycTierCheck';
import { ROUTES } from 'Router/Routes';
import RedeemError from "./RedeemError";
import LoadingSpinner from 'Components/shared/LoadingSpinner';

const Redeem = () => {
  const history = useHistory();
  const { isAdmin, status } = useContext(AuthContext);
  const {
    config: { kycTierFunctionalRestrictions },
  } = useContext(ConfigContext);
  const { isUserTierSufficient } = useKycTierCheck(
    kycTierFunctionalRestrictions?.visibility?.redemption
  );
  const { isRestrictedMode } = useConfigSettings.query({
    refetchOnMount: false,
    select: data => data.RestrictedMode
  });
  const location = useLocation();
  const isBaseRedemptionRoute = !!matchPath(
    location.pathname,
    { path: ROUTES.redemption, exact: true }
  );

  useEffect(() => {
    const fetchBankRedemptionMethod = async () => {
      try {
        const { value: bankRedemptionMethods } = await api.Redemptions.getMethodsConfig({
          filter: "Enabled and Type eq 'Bank'",
          top: 1
        });
        if (!bankRedemptionMethods.length) {
          history.replace(ROUTES.base);
        }
        history.replace(`/redemption/details/${bankRedemptionMethods[0].Id}`)
      } catch (error) {
        history.replace(ROUTES.base);
      }
    };
    if (!isUserTierSufficient) {
      history.replace(ROUTES.base);
    }
    if (isBaseRedemptionRoute) {
      fetchBankRedemptionMethod();
    }
  }, [isBaseRedemptionRoute]);

  const storedRedemption = sessionStorage.getItem(STORAGE_KEYS.allowedRedemption);
  const restrictedModeRedirectPath = storedRedemption
    ? generatePath(
        ROUTES.redemptionForm,
        { id: storedRedemption }
      )
    : ROUTES.welcome

  return (
    <div
      className="main-content-wrapper h-full flex flex-col"
    >
      {isBaseRedemptionRoute ? (
        <div className = "flex justify-center px-32 py-24">
            <LoadingSpinner />
        </div>
      ) : (
        <Switch>
          {(!isRestrictedMode || isAdmin) && (
            <Route exact path={ROUTES.redemption}>
              <RedeemDetails />
            </Route>
          )}
          {status === USER_STATUS.Approved && (
            <Switch>
              <Route exact path={ROUTES.redemptionForm}>
                <RedeemDetails />
              </Route>
              <Route exact path={ROUTES.redemptionSummary}>
                <RedemptionSummary />
              </Route>
              <Route exact path={ROUTES.redemptionQR}>
                <RedeemQr />
              </Route>
              <Route exact path={ROUTES.redemptionFinish}>
                <RedeemFinish />
              </Route>
              <Route path={ROUTES.redemptionError}>
                <RedeemError />
              </Route>
            </Switch>
          )}
          <Route>
            <Redirect
              to={
                isRestrictedMode && !isAdmin
                  ? restrictedModeRedirectPath
                  : ROUTES.redemption
              }
            />
          </Route>
        </Switch>
      )}
    </div>
  );
};

export default Redeem;
